export const sealUrl = (safeNumber) => {
  let url = [];

  for (let i = 1; i < 6; i++) {
    url.push(`https://seal.creditsafe.com/${i}/${safeNumber}.png`);
  }

  return url;
};
